import Lottie from 'lottie-react';
import scroll from '../assets/visual/lottie/scroll.json';

// dynamic props 수정 필요
const Scroll = () => (
	<Lottie
		animationData={scroll}
		loop={true}
		style={{ width: '20%', height: '30%' }}
	/>
);

export default Scroll;
